import { render, staticRenderFns } from "./DebtorsFileUploader.vue?vue&type=template&id=506baef0&scoped=true"
import script from "./DebtorsFileUploader.vue?vue&type=script&lang=js"
export * from "./DebtorsFileUploader.vue?vue&type=script&lang=js"
import style0 from "./DebtorsFileUploader.vue?vue&type=style&index=0&id=506baef0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506baef0",
  null
  
)

export default component.exports